module.exports = __webpack_public_path__ + "media/images/USA-banner2-01f3b880995cee214bd668356d48215d.jpg";